import { AdminRouter } from 'stylemix-vue-admin'
import {messageGroups} from "../../../console/src/plugins/i18n";

const base = 'widget'

AdminRouter.addRoutes([
  {
    name: `${base}`,
    path: `/${base}`,
    component: () => import('./Widget.vue'),
    meta: {
      auth: true,
    },
  },
])

messageGroups.push('general')
messageGroups.push('settings')
